import React, {Component} from 'react';
import {Col, Row, Typography, Button} from "antd";
import {Redirect} from "react-router-dom";
import {t} from '../../../constant/i18n';


const {Title} = Typography;

class MethodeReg extends Component {


    constructor(props) {
        super(props);
        this.state = {
            displayForm: false,
            displayMethode: true,
            redirectionIdent: false,
        }
    }

    clickIdent = () => {
        //this.props.changeMethAction(true)
        this.setState({redirectionIdent:true})
    }

    clickCreat = () => {
        this.props.changeMethAction(true)
    }

    render() {

        if (this.state.redirectionIdent) {
            //Affichage de la redirection
            return <Redirect to='/order/ident'/>;
        }

        return (
            <div>
                <Row>
                    <Col lg={12}>
                        <div className="centerTxt mb10 mt10">
                            <Title level={3}>{t('methodeReg.noAccount')}</Title>
                        </div>
                        <Row className="center" style={{marginBottom: "20px"}}>
                            <Col span={24}>
                                <Button onClick={this.clickCreat} type="primary" htmlType="button" size="large" style={{minWidth: "250px"}}>
                                    {t('methodeReg.createAccount')}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12}>
                        <div className="centerTxt mb10 mt10">
                            <Title level={3}>{t('methodeReg.haveAccount')}</Title>
                        </div>
                        <div className="center">
                            <Button onClick={this.clickIdent} type="primary" htmlType="button" size="large"
                                    style={{minWidth: "250px"}}>
                                {t('methodeReg.signIn')}
                            </Button>
                        </div>

                    </Col>
                </Row>
            </div>
        );
    }
}

export default MethodeReg;